import { useCallback, useMemo } from 'react';
import { AccountBalance } from './types';
import { useService } from '../common';
import type { ServiceResponse } from '../common/types';

const API = {
    ACCOUNT_BALANCE: '/account/balance',
    ACCOUNT_BALANCE_V2: '/account/balance',
    DEPOSIT_FUNDS: '/account-balance/deposit',
    RECONCILE_BALANCE: '/account/reconcile-balance'
};

export const useAccountService = () => {
    const service = useService();
    const getAccountBalance = useCallback((): Promise<AccountBalance> => {
        return service.sendGetWithAuthorization(API.ACCOUNT_BALANCE)
            .then(service.handleResponse)
            .catch((error) => Promise.resolve(error));
    }, [service]);

    const depositFunds = useCallback((amount: number): ServiceResponse => {
        return service.sendPostWithAuthorization(API.DEPOSIT_FUNDS, { amount })
            .then(service.handleResponse)
            .catch(error => Promise.resolve(error));
    }, [service]);

    return useMemo(() => ({
        getAccountBalance,
        depositFunds
    }), [getAccountBalance, depositFunds]);
};
